var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 28H3a3 3 0 01-3-3V8a3 3 0 013-3h26a3 3 0 013 3v17a3 3 0 01-3 3zM3 7a1 1 0 00-1 1v17a1 1 0 001 1h26a1 1 0 001-1V8a1 1 0 00-1-1H3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24a1 1 0 01-.89-.54l-4.83-9.3-4.82 9.12a1 1 0 01-1.74.06L9.3 17.78l-3.44 5.73a1 1 0 11-1.72-1l4.29-7.15a1 1 0 01.85-.49 1 1 0 01.85.48l3.37 5.47 4.9-9.29a1 1 0 011.77.01l5.72 11a1.001 1.001 0 01-.43 1.35c-.143.07-.3.108-.46.11zm-.5-13a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
  })));
}

export default SvgPhoto;